import React, { Component } from 'react';
import { inject } from 'mobx-react';
import { withStyles } from '@material-ui/core/styles';

import { Video as BasePlayer } from '../shared';

const styles = () => ({
  root: {},
});

const mapper = (stores) => ({
  onStart: () => {
    if (!!window.ga) {
      window.ga('send', 'event', 'Videos', 'play', 'Trailer');
    }
    return stores.analytics.event({
      category: 'Video',
      action: 'Play',
      label: 'Trailer',
    });
  },
  onPlay: () => {
    stores.soundtrack.pause();
  },
});

class Video extends Component {
  state = {
    allreadyPlayed: false,
  };
  render() {
    const { classes } = this.props;
    return (
      <BasePlayer
        id="trailer"
        className={classes.root}
        onPlay={this._handleStart}
      />
    );
  }

  _handleStart = () => {
    const { onStart, onPlay } = this.props;

    onPlay();

    if (!!this.state.allreadyPlayed) return;
    try {
      this.setState({ allreadyPlayed: true }, () => {
        onStart && onStart();
      });
    } catch (e) {}
  };
}

export default inject(mapper)(withStyles(styles)(Video));
